import { Controller } from "@hotwired/stimulus"

// Preseleziona il fuso del browser alla prima visita e ricarica gli slot.
//
// ActiveSupport::TimeZone espone nomi "Rails" (es. "Rome") come value delle
// option, mentre Intl.DateTimeFormat restituisce identificatori IANA (es.
// "Europe/Rome"): non sono direttamente confrontabili. Il server calcola la
// mappa IANA -> nome Rails (ActiveSupport::TimeZone::MAPPING.invert) e la
// espone come data attribute; qui si usa quella mappa per risalire al nome
// Rails da preselezionare, senza ricalcolare nulla lato client.
export default class extends Controller {
  static values = { url: String, preselect: Boolean, mapping: Object }

  connect() {
    if (!this.preselectValue) return

    const browserZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const railsName = this.mappingValue[browserZone]
    if (!railsName) return

    const match = Array.from(this.element.options).find((o) => o.value === railsName)
    if (match && this.element.value !== railsName) {
      this.element.value = railsName
      this.apply()
    }
  }

  apply() {
    document.cookie = `booking_tz=${encodeURIComponent(this.element.value)};path=/;max-age=31536000;samesite=lax`
    const url = new URL(this.urlValue, window.location.origin)
    new URLSearchParams(window.location.search).forEach((v, k) => url.searchParams.set(k, v))
    url.searchParams.set("tz", this.element.value)
    Turbo.visit(url.toString(), { frame: "booking_slots" })
  }
}
